<template>
    <div class="jetty-card" :style="{ borderColor: dayStatus == 1 && nightStatus == 1 ? '#00bd7d' : '#dadada' }">
        <div class="flex flex-row justify-between content-center items-center">
            <div class="flex flex-row">
                <div class="jetty-index"
                    :style="{ backgroundColor: dayStatus == 1 && nightStatus == 1 ? '#00bd7d' : '#45566c' }">
                    Jetty {{ jettyNo }}
                </div>
            </div>

            <i v-if="dayStatus == 1 && nightStatus == 1" class="pi pi-check-circle status-check"></i>
        </div>

        <div class="divider-hori"></div>

        <!-- DAY SHIFT -->
        <div class="shift-wrapper" @click="handleShiftClick('DAY', dayStatus)"
            :style="{ backgroundColor: dayStatus == 1 ? '#d1fae5' : '#f9fafb', borderColor: dayStatus == 1 ? '#00bd7d' : '#dadada' }">
            <div class="flex flex-row justify-between items-center">
                <div>
                    <i class="pi pi-sun" :style="{ color: dayStatus == 1 ? '#289270' : '#3b4657' }"></i>
                    <span class="font-semibold" :style="{ color: dayStatus == 1 ? '#289270' : '#3b4657' }">
                        Day Shift
                    </span>
                </div>

                <div class="action-link" :class="{ disabled: isShiftDisabled('DAY', dayStatus) }">
                    <span :style="{ color: dayStatus == 1 ? '#289270' : '#3b4657' }">
                        {{ getShiftLabel('DAY', dayStatus) }}
                    </span>
                    <span :style="{ color: dayStatus == 1 ? '#289270' : '#3b4657' }">
                        <i class="pi pi-angle-right"></i>
                    </span>
                </div>
            </div>
        </div>

        <!-- NIGHT SHIFT -->
        <div class="shift-wrapper" @click="handleShiftClick('NIGHT', nightStatus)"
            :style="{ backgroundColor: nightStatus == 1 ? '#d1fae5' : '#f9fafb', borderColor: nightStatus == 1 ? '#00bd7d' : '#dadada' }">
            <div class="flex flex-row justify-between items-center">
                <div>
                    <i class="pi pi-moon" :style="{ color: nightStatus == 1 ? '#289270' : '#3b4657' }"></i>
                    <span class="font-semibold" :style="{ color: nightStatus == 1 ? '#289270' : '#3b4657' }">
                        Night Shift
                    </span>
                </div>

                <div class="action-link" :class="{ disabled: isShiftDisabled('NIGHT', nightStatus) }">
                    <span :style="{ color: nightStatus == 1 ? '#289270' : '#3b4657' }">
                        {{ getShiftLabel('NIGHT', nightStatus) }}
                    </span>
                    <span :style="{ color: nightStatus == 1 ? '#289270' : '#3b4657' }">
                        <i class="pi pi-angle-right"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JettyCard',
    props: {
        dayEntries: {
            type: Array,
            default: () => []
        },
        nightEntries: {
            type: Array,
            default: () => []
        },
        index: Number,
        jettyNo: Number,
        dayStatus: Number,
        nightStatus: Number,
        checkDate: {
            type: String,
            default: ''
        },
        viewOnly: {
            type: Boolean,
            default: false
        },
        previousDayLastEntry: {
            type: Object,
            default: null
        },
        previousNightLastEntry: {
            type: Object,
            default: null
        },
        previousDate: {
            type: String,
            default: ''
        }
    },
    computed: {
        currentSeconds() {
            const now = new Date()
            return now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()
        }
    },
    methods: {
        isShiftInRange(shiftType) {
            const current = this.currentSeconds

            if (shiftType === 'DAY') {
                const dayStart = 8 * 3600
                const dayEnd = 19 * 3600 + 59 * 60 + 59
                return current >= dayStart && current <= dayEnd
            }

            if (shiftType === 'NIGHT') {
                const nightStart = 20 * 3600
                const nightEnd = 7 * 3600 + 59 * 60 + 59
                return current >= nightStart || current <= nightEnd
            }

            return false
        },

        isShiftDisabled(shiftType, status) {
            const inRange = this.isShiftInRange(shiftType)

            return status === 0 && !inRange
        },

        getShiftLabel(shiftType, status) {
            const inRange = this.isShiftInRange(shiftType)

            if (this.viewOnly && inRange) {
                return 'View Only'
            }

            if (status === 0) {
                return inRange ? 'Fill Form' : 'Disabled'
            }

            if (status === 1 && !this.viewOnly && inRange) {
                return 'View / Edit'
            }

            return 'View Only'
        },

        handleShiftClick(shiftType, status) {
            const inRange = this.isShiftInRange(shiftType)

            if (status === 0 && !inRange) return

            let viewOnly = this.viewOnly

            if (status === 1 && !inRange) {
                viewOnly = true
            }

            const entries = shiftType === 'DAY' ? this.dayEntries : this.nightEntries
            const ids = entries.map(item => item.id)

            let previousShiftType = ''
            let previousShiftDate = ''
            let previousEntryId = ''

            if (shiftType === 'DAY') {
                previousShiftType = 'NIGHT'
                previousShiftDate = this.previousDate
                previousEntryId = this.previousNightLastEntry?.id || ''
            }

            if (shiftType === 'NIGHT') {
                previousShiftType = 'DAY'
                previousShiftDate = this.checkDate
                previousEntryId = this.previousDayLastEntry?.id || ''
            }

            this.$router.push({
                path: '/jettyChecklist/index/form',
                query: {
                    jettyNo: this.jettyNo,
                    shiftType,
                    date: this.checkDate,
                    viewOnly: viewOnly ? '1' : '0',
                    ids: JSON.stringify(ids),
                    previousShiftType,
                    previousShiftDate,
                    previousEntryId
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.jetty-card {
    background-color: white;
    border-radius: 10px;
    border: 2px solid;
    height: 200px;
    padding: 20px;

    .divider-hori {
        width: 100%;
        height: 0.5px;
        background: rgb(218, 218, 218);
        margin-top: 12px;
        border-radius: 1px;
        padding: 0;
    }

    .status-check {
        color: #0f9f66;
        font-weight: 800;
        font-size: 20px;
    }
}

.jetty-index {
    border-radius: 10px;
    font-size: 14px;
    padding-inline: 12px;
    color: white;
    text-align: center;
    align-content: center;
    font-weight: 600;
    padding-block: 4px;
}

.shift-wrapper {
    background-color: #f9fafb;
    min-height: 44px;
    padding: 8px 12px;
    border-radius: 10px;
    border: 2px solid #e9eaee;
    margin-block: 12px;

    span {
        font-size: 14px;
        margin-left: 8px;
    }
}

.action-link {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.action-link.disabled {
    opacity: 0.45;
    cursor: not-allowed;
    pointer-events: none;
}
</style>